import React, {Component} from 'react';
import './Button.css'

class Button extends Component {

    static defaultProps = {
        classes: null,
    };

    // constructor(props) {
    //
    //     super(props);
    //     // this.state = {
    //     //     floatingTimerange: false,
    //     //     startDate: start,
    //     //     endDate: end
    //     // };
    //
    // };


    // componentWillUnmount() {
    //     // console.debug("Unmount MachineContainer");
    // }
    //
    // componentWillMount() {
    //     // console.debug("Mount MachineContainer");
    // }

    render() {
        let click = this.props.onClick ? this.props.onClick : null;
        let className = "button";

        if (this.props.disabled) {
            className += ' button-disabled';
            click = null;
        }

        if (this.props.Active && this.props.Active === true) {
            className += ' button-active';
        }

        className = [className, this.props.classes].join(' ').trim();

        return (
            <button
                className={className} style={this.props.style ? this.props.style : {}}
                onClick={click}>{this.props.Text}
            </button>
        );
    }
}

export default Button;


